import { render } from "./AdminAccommodationInquiryDetailsView.vue?vue&type=template&id=2a3273fa&ts=true&lang=pug"
import script from "./AdminAccommodationInquiryDetailsView.vue?vue&type=script&lang=ts"
export * from "./AdminAccommodationInquiryDetailsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__